<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { FlowDestinationWidgetQC } from '@/widgets/Flow'

  useApiRequestsAbort()
</script>

<template>
  <FlowDestinationWidgetQC />
</template>
